import AppRoutes from './AppRoutes.component';

export * from './interfaces';
export default AppRoutes;
